import React from 'react'

function error() {
  return (
    <>
      <h1 style={{ color: 'white' }}>La pagina no se ha encontrado</h1>
    </>
  )
}

export default error